import type { ButtonHTMLAttributes, ReactNode } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "ghost" | "danger";
  size?: "md" | "lg";
  children: ReactNode;
}

const base =
  "inline-flex items-center justify-center gap-2 font-text font-medium tracking-wide transition-colors duration-[var(--duration-fast)] disabled:opacity-50 disabled:cursor-not-allowed select-none";
const sizes = {
  md: "min-h-[44px] px-4 text-[15px]",
  lg: "min-h-[48px] px-5 text-[17px]",
};
const variants = {
  primary:
    "bg-blaze text-white hover:bg-blaze-dim rounded-[var(--radius-control)] border border-blaze",
  secondary:
    "bg-transparent text-granite-800 hover:bg-granite-100 rounded-[var(--radius-control)] border border-granite-300",
  ghost:
    "bg-transparent text-granite-600 hover:text-granite-800 hover:bg-granite-100 rounded-[var(--radius-control)]",
  danger:
    "bg-transparent text-blaze hover:bg-blaze/10 rounded-[var(--radius-control)] border border-blaze/40",
};

export function Button({ variant = "primary", size = "md", className = "", children, ...rest }: ButtonProps) {
  return (
    <button className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} {...rest}>
      {children}
    </button>
  );
}
